module.exports = __webpack_public_path__ + "img/10.a8b7f79e.png";